/** Age helpers for care-circle subjects (aligned with backend age_in_months). */

function daysInMonth(year, month) {
  // month is 1–12
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

/**
 * Completed age in whole months.
 * Without a birth day, assumes the last day of the birth month so age is never overstated.
 */
export function ageInMonths(birthYear, birthMonth, now = new Date()) {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth() + 1;
  const d = now.getUTCDate();
  const birthDay = daysInMonth(birthYear, birthMonth);
  let months = (y - birthYear) * 12 + (m - birthMonth);
  if (d < birthDay) months -= 1;
  return Math.max(0, months);
}

/** Approximate age in whole years (month-aware when birthMonth is set). */
export function approxAgeYears(birthYear, birthMonth = null, now = new Date()) {
  if (birthMonth != null && birthMonth !== "") {
    const monthNum = parseInt(birthMonth, 10);
    if (!Number.isNaN(monthNum)) {
      return Math.floor(ageInMonths(birthYear, monthNum, now) / 12);
    }
  }
  return now.getUTCFullYear() - birthYear;
}

/**
 * Whether birth_month is required (age under 2).
 * Year-only: require for year-diff 0–2 (age 2 may still be under 24 months).
 */
export function needsBirthMonth(birthYear, birthMonth = null, now = new Date()) {
  if (birthYear == null || Number.isNaN(birthYear)) return false;
  if (birthMonth != null && birthMonth !== "") {
    const monthNum = parseInt(birthMonth, 10);
    if (!Number.isNaN(monthNum)) {
      return ageInMonths(birthYear, monthNum, now) < 24;
    }
  }
  const yearAge = now.getUTCFullYear() - birthYear;
  return yearAge <= 2;
}
